import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {StatusesService} from '@catcore/services/statuses.service';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class StatusesResolve implements Resolve<any> {
  constructor(protected statusService: StatusesService,
              protected router: Router,
  ) {
  }

  /**
   * Loads the project-info based on a provided :projectId and returns a Observable
   */
  public resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    return this.statusService.getAll();
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/features/services/statuses.resolve.ts